import type { ValidIconName } from './Icon';
import { Icon } from './Icon';
import React from 'react';
import type { UseHoverOptions, UseLayerOptions } from 'react-laag';
import { useHover } from 'react-laag';
import { useLayerDeferedVisibility } from '../../lib';
import { DEFAULT_HOVER_CONFIG, DEFAULT_PLACEMENT_CONFIG } from '../../util';

export type IconToolTipProps = {
  tooltip: string;
  tooltipOptions?: Partial<UseHoverOptions> & Partial<UseLayerOptions>;
  iconName: ValidIconName;
  className?: string;
  id?: string;
};
export function IconToolTip({
  tooltip,
  tooltipOptions,
  iconName,
  className,
  id
}: Readonly<IconToolTipProps>): React.JSX.Element {
  const [isOpen, hoverProps] = useHover({
    delayEnter: tooltipOptions?.delayEnter ?? DEFAULT_HOVER_CONFIG.delayEnter,
    delayLeave: tooltipOptions?.delayLeave ?? DEFAULT_HOVER_CONFIG.delayLeave,
    hideOnScroll: tooltipOptions?.hideOnScroll
  });
  const { renderLayer, triggerProps, layerProps } = useLayerDeferedVisibility({
    isOpen,
    ...DEFAULT_PLACEMENT_CONFIG
  });
  const classNames = ['ehs-icon-tooltip'];
  if (className) {
    classNames.push(className);
  }
  return (
    <div className={classNames.join(' ')} id={id}>
      <Icon
        {...triggerProps}
        {...hoverProps}
        aria-label={tooltip}
        iconName={iconName}
      />
      {isOpen &&
        renderLayer(
          <div {...layerProps} className="ehs-tooltip">
            {tooltip}
          </div>
        )}
    </div>
  );
}
